var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"client-login"}},[_c('TheDebugBar'),_c('v-main',{staticClass:"white"},[_c('v-container',{class:[
        _vm.noFillHeight ? '' : 'fill-height',
        _vm.noGutters ? 'ma-0 pa-0' : '' ],attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }